import apiClient from "services/apiClient";

async function addBasicReport(data: any) {
  const url = `/admin/reports/basic`;

  const res = await apiClient.post(url, data);

  return res.data;
}

export default addBasicReport;
